var _path, _path2, _path3, _path4, _path5, _path6, _rect, _rect2, _rect3, _rect4, _path7, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg500(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 449,
    height: 173,
    viewBox: "0 0 449 173",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M114.805 34.2988H38.3527V74.9212C41.852 70.8133 46.6445 67.5422 52.7303 65.1079C58.9682 62.5214 65.8147 61.2282 73.2697 61.2282C84.3762 61.2282 93.5809 63.6625 100.884 68.5311C108.339 73.2476 113.816 79.6376 117.315 87.7012C120.967 95.6127 122.793 104.437 122.793 114.174C122.793 131.367 117.924 145.136 108.187 155.481C98.6017 165.827 84.8326 171 66.8797 171C55.1646 171 44.971 168.946 36.2988 164.838C27.6266 160.578 20.8562 154.721 15.9875 147.266C11.1189 139.658 8.45643 130.834 8 120.793H39.2656C40.4827 127.639 43.2974 133.116 47.7095 137.224C52.1217 141.18 57.9793 143.158 65.2822 143.158C74.1065 143.158 80.6487 140.495 84.9087 135.17C89.3209 129.693 91.527 122.466 91.527 113.49C91.527 104.97 89.2448 98.3513 84.6805 93.6349C80.1162 88.9184 73.6501 86.5602 65.2822 86.5602C59.1964 86.5602 54.0235 87.9295 49.7635 90.6681C45.5035 93.2545 42.3845 96.7538 40.4066 101.166H9.14108V6H114.805V34.2988Z",
    fill: "url(#paint0_linear_1782_3215)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M106.805 30.2988H30.3527V70.9212C33.852 66.8133 38.6445 63.5422 44.7303 61.1079C50.9682 58.5214 57.8147 57.2282 65.2697 57.2282C76.3762 57.2282 85.5809 59.6625 92.8838 64.5311C100.339 69.2476 105.816 75.6376 109.315 83.7012C112.967 91.6127 114.793 100.437 114.793 110.174C114.793 127.367 109.924 141.136 100.187 151.481C90.6017 161.827 76.8326 167 58.8797 167C47.1646 167 36.971 164.946 28.2988 160.838C19.6266 156.578 12.8562 150.721 7.98755 143.266C3.11895 135.658 0.456431 126.834 0 116.793H31.2656C32.4827 123.639 35.2974 129.116 39.7095 133.224C44.1217 137.18 49.9793 139.158 57.2822 139.158C66.1065 139.158 72.6487 136.495 76.9087 131.17C81.3209 125.693 83.527 118.466 83.527 109.49C83.527 100.97 81.2448 94.3513 76.6805 89.6349C72.1162 84.9184 65.6501 82.5602 57.2822 82.5602C51.1964 82.5602 46.0235 83.9295 41.7635 86.6681C37.5035 89.2545 34.3845 92.7538 32.4066 97.166H1.14108V2H106.805V30.2988Z",
    fill: "#1E1E1E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M382.476 173C423.89 173 448.899 141.477 448.979 87.1961C449.06 33.3177 423.729 2.43799 382.476 2.43799C341.142 2.43799 316.052 33.2372 315.972 87.1961C315.811 141.316 340.981 172.92 382.476 173ZM382.476 144.131C363.578 144.131 351.354 125.153 351.435 87.1961C351.516 49.8029 363.658 30.9856 382.476 30.9856C401.212 30.9856 413.436 49.8029 413.436 87.1961C413.516 125.153 401.293 144.131 382.476 144.131Z",
    fill: "url(#paint1_linear_1782_3215)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M372.391 170.562C413.805 170.562 438.814 139.039 438.894 84.7581C438.975 30.8797 413.644 0 372.391 0C331.057 0 305.967 30.7992 305.887 84.7581C305.726 138.878 330.896 170.482 372.391 170.562ZM372.391 141.693C353.493 141.693 341.27 122.715 341.35 84.7581C341.431 47.3649 353.573 28.5476 372.391 28.5476C391.127 28.5476 403.351 47.3649 403.351 84.7581C403.431 122.715 391.208 141.693 372.391 141.693Z",
    fill: "#47AD1D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M219.382 173C260.796 173 285.806 141.477 285.886 87.1961C285.966 33.3177 260.636 2.43799 219.382 2.43799C178.049 2.43799 152.959 33.2372 152.878 87.1961C152.717 141.316 177.887 172.92 219.382 173ZM219.382 144.131C200.484 144.131 188.261 125.153 188.342 87.1961C188.422 49.8029 200.565 30.9856 219.382 30.9856C238.119 30.9856 250.342 49.8029 250.342 87.1961C250.423 125.153 238.2 144.131 219.382 144.131Z",
    fill: "url(#paint2_linear_1782_3215)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M209.297 170.562C250.711 170.562 275.721 139.039 275.801 84.7581C275.881 30.8797 250.551 0 209.297 0C167.964 0 142.874 30.7992 142.793 84.7581C142.632 138.878 167.802 170.482 209.297 170.562ZM209.297 141.693C190.399 141.693 178.176 122.715 178.257 84.7581C178.337 47.3649 190.48 28.5476 209.297 28.5476C228.034 28.5476 240.257 47.3649 240.257 84.7581C240.338 122.715 228.115 141.693 209.297 141.693Z",
    fill: "#47AD1D"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 164.573,
    y: 54,
    width: 38.731,
    height: 9.29544,
    transform: "rotate(45 164.573 54)",
    fill: "#1E1E1E"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 158,
    y: 81.3872,
    width: 38.731,
    height: 9.29544,
    transform: "rotate(-45 158 81.3872)",
    fill: "#1E1E1E"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 233.573,
    y: 54,
    width: 38.731,
    height: 9.29544,
    transform: "rotate(45 233.573 54)",
    fill: "#1E1E1E"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 227,
    y: 81.3872,
    width: 38.731,
    height: 9.29544,
    transform: "rotate(-45 227 81.3872)",
    fill: "#1E1E1E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M230.364 124.272C229.283 121.664 227.699 119.294 225.703 117.297C223.706 115.301 221.336 113.717 218.728 112.637C216.119 111.556 213.324 111 210.5 111C207.677 111 204.881 111.556 202.272 112.637C199.664 113.717 197.294 115.301 195.297 117.297C193.301 119.294 191.717 121.664 190.637 124.272",
    stroke: "#1E1E1E",
    strokeWidth: 9
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1782_3215",
    x1: 80.8161,
    y1: 209.215,
    x2: -18.6382,
    y2: 28.766,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E1E1E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1782_3215",
    x1: 400.342,
    y1: 212.504,
    x2: 304.045,
    y2: 16.6591,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#47AD1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#47AD1D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1782_3215",
    x1: 237.249,
    y1: 212.504,
    x2: 140.952,
    y2: 16.6591,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#47AD1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#47AD1D",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg500);
export default __webpack_public_path__ + "static/media/500.d9c71a1bd4ec0543b047a4784905b7e6.svg";
export { ForwardRef as ReactComponent };